// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import {
    MutationChangeCustomerOptionArgs,
    MutationCreateCustomerOptionArgs,
    MutationDeleteCustomerOptionArgs,
} from '../../../mdqx-graphql-types';
import { CustomerOptionsEntity } from '../../../entities/mdqx/customer-options.entity';

export enum CustomerOptionsActionTypes {
    GetCustomerOptionsRequest = '[CustomerOptions] Get Request',
    GetCustomerOptionsResponse = '[CustomerOptions] Get Response',
    PostCustomerOptionsRequest = '[CustomerOptions] Post Request',
    PostCustomerOptionsResponse = '[CustomerOptions] Post Response',
    PatchCustomerOptionsRequest = '[CustomerOptions] Patch Request',
    PatchCustomerOptionsResponse = '[CustomerOptions] Patch Response',
    DeleteCustomerOptionsRequest = '[CustomerOptions] Delete Request',
    DeleteCustomerOptionsResponse = '[CustomerOptions] Delete Response',
}

export class GetCustomerOptionsRequest implements Action {
    readonly type = CustomerOptionsActionTypes.GetCustomerOptionsRequest;
}

export class GetCustomerOptionsResponse implements Action {
    readonly type = CustomerOptionsActionTypes.GetCustomerOptionsResponse;
    constructor(public Payload: CustomerOptionsEntity[]) {}
}

export class PostCustomerOptionsRequest implements Action {
    readonly type = CustomerOptionsActionTypes.PostCustomerOptionsRequest;
    constructor(public Payload: MutationCreateCustomerOptionArgs) {}
}

export class PostCustomerOptionsResponse implements Action {
    readonly type = CustomerOptionsActionTypes.PostCustomerOptionsResponse;
    constructor(public Payload: CustomerOptionsEntity) {}
}

export class PatchCustomerOptionsRequest implements Action {
    readonly type = CustomerOptionsActionTypes.PatchCustomerOptionsRequest;
    constructor(public Payload: MutationChangeCustomerOptionArgs) {}
}

export class PatchCustomerOptionsResponse implements Action {
    readonly type = CustomerOptionsActionTypes.PatchCustomerOptionsResponse;
    constructor(public Payload: CustomerOptionsEntity) {}
}

export class DeleteCustomerOptionsRequest implements Action {
    readonly type = CustomerOptionsActionTypes.DeleteCustomerOptionsRequest;
    constructor(public Payload: MutationDeleteCustomerOptionArgs) {}
}

export class DeleteCustomerOptionsResponse implements Action {
    readonly type = CustomerOptionsActionTypes.DeleteCustomerOptionsResponse;
    constructor(public Payload: number) {}
}

export type CustomerOptionsActions =
    | GetCustomerOptionsRequest
    | GetCustomerOptionsResponse
    | PostCustomerOptionsRequest
    | PostCustomerOptionsResponse
    | PatchCustomerOptionsRequest
    | PatchCustomerOptionsResponse
    | DeleteCustomerOptionsRequest
    | DeleteCustomerOptionsResponse;
